<script lang="ts">
  import { t } from "$lib/i18n";
  import { applyUpdate, skipUpdate, swState } from "$lib/sw.svelte";
</script>

<div class="sw_popup" class:active={swState.updateAvailable} id="sw-toast">
  {t("system.update_available")}
  <div>
    <button onclick={() => void applyUpdate()}>{t("system.update_now")}</button>
    <button onclick={() => void skipUpdate()}>{t("system.skip_update")}</button>
  </div>
</div>

<style>
  .sw_popup {
    position: absolute;
    top: 0;
    right: 50%;
    padding: 20px 40px;
    display: flex;
    flex-direction: column;
    color: white;
    justify-content: center;
    align-items: center;
    background-color: black;
    transform: translate(50%, -110%);
    gap: 20px;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    transition: transform 1s ease-in-out;
    z-index: 999;
  }

  .sw_popup.active {
    transform: translate(50%, 0);
  }

  .sw_popup > div {
    display: flex;
    flex-direction: row;
    gap: 20px;
  }

  .sw_popup button {
    outline: none;
    border: none;
    background: #e5e5e5;
    color: black;
    padding: 10px 0;
    width: 100px;
    border-radius: 4px;
    cursor: pointer;
  }
</style>
